import { ActionModal, colors, typography } from '@insurancemenu/imenu-components-lib';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils';
import styled from 'styled-components';

export const ActionModalStyled = styled(ActionModal)`
  max-width: 90rem;
  width: 80%;
`;

export const ModalBodyStyled = styled.div`
  text-align: left;
`;

export const AddFamilyMemberSectionStyled = styled.div`
  background-color: ${colors.neutral[100]};
  border-radius: 10px;
  margin-top: 4rem;
  padding: 2rem 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 6rem;

  ${breakpointsMQ4.md.down} {
    flex-direction: column;
    align-items: center;
    padding: 2rem;
    gap: 2rem;
  }
`;

export const AddFamilyMemberTextSectionStyled = styled.div`
  max-width: 50%;
  ${breakpointsMQ4.md.down} {
    max-width: 100%;
  }
`;

export const AddFamilyMemberTitleStyled = styled.h3`
  ${typography.bold[20]}
  margin: 0 0 1rem;
  color: ${colors.neutral[900]};
`;

export const AddFamilyMemberTextStyled = styled.p`
  ${typography.regular[16]}
  margin: 0;
  color: ${colors.neutral[700]};
`;
